module.exports = __webpack_public_path__ + "img/how_to_play_banner.e17cc483.png";